var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvery = function SvgEvery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#2226F7",
    rx: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00FF93",
    fillRule: "evenodd",
    d: "M14.253 6.42c0 1.278-.92 2.343-2.139 2.58a2.636 2.636 0 0 1 2.138 2.58c0 1.451-1.187 2.629-2.652 2.629A2.65 2.65 0 0 1 9 12.094a2.65 2.65 0 0 1-2.602 2.113c-1.464 0-2.652-1.177-2.652-2.63 0-1.275.917-2.339 2.133-2.578a2.636 2.636 0 0 1-2.133-2.578c0-1.452 1.187-2.63 2.652-2.63 1.288 0 2.36.91 2.602 2.117A2.65 2.65 0 0 1 11.6 3.791c1.465 0 2.652 1.177 2.652 2.63M6.917 9A2.64 2.64 0 0 0 9 6.932 2.64 2.64 0 0 0 11.087 9 2.64 2.64 0 0 0 9 11.064a2.64 2.64 0 0 0-2.083-2.065",
    clipRule: "evenodd"
  })));
};
export default SvgEvery;